<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>교육 신청</p></li>
            <li><p>교육 신청</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>외식 경영 관리사 교육 신청 </span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl_big">
                    <p>
                      {{ item.title }}
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="inform_box mtb10">
                    <ol class="dot">
                      <li class="color">
                        <span class="ol_li_txt">
                          교육신청 후에는 시험일정 등 변경이 불가하므로 접수 시
                          확인하여 착오 없으시기 바랍니다.<br />
                          (변경 필요 시에는 본 협회로 연락주시기 바랍니다.)
                        </span>
                      </li>
                    </ol>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>종목명</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">외식경영 관리사</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육번호</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">신청 시 발급 됩니다.</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육신청</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.rating }}급</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육장소</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.eduAddress }}</p>
                  </div>
                </li>
                <li class="form_li top_bo">
                  <div class="form_ttl">
                    <p class="essen">이름</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="이름을 입력해 주세요"
                        v-model="form.name"
                      />
                      <p class="valid" :class="{ on: $v.form.name.$error }">
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">생년월일</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="생년월일을 입력해 주세요"
                        v-model="form.userBirth"
                        maxlength = "8"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <p class="hint">
                        생년월일 8자리(ex: 20200131)를 입력해 주세요.
                      </p>
                      <p
                        class="valid"
                        :class="{ on: $v.form.userBirth.$error }"
                      >
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">이메일</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="email"
                        placeholder="이메일을 입력해 주세요"
                        v-model="form.email"
                      />
                      <p class="valid" :class="{ on: $v.form.email.$error }">
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>장애여부</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="radio">
                        <input
                          type="radio"
                          name="a"
                          id="aa"
                          :value="1"
                          v-model="form.isDisorder"
                        />
                        <label for="aa"><span>해당 없음</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="a"
                          id="ab"
                          :value="2"
                          v-model="form.isDisorder"
                        />
                        <label for="ab"><span>해당 있음</span></label>
                      </div>
                    </div>
                    <p class="valid" :class="{ on: $v.form.isDisorder.$error }">
                      필수항목입니다.
                    </p>
                    <!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>편의요청사항</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="장애 여부에 해당하는 경우에만 작성해 주세요"
                        v-model="form.memo"
                      />
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">주소</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="input">
                        <input
                          type="number"
                          placeholder="우편 번호"
                          disabled
                          v-model="form.postalCode"
                        />
                      </div>
                      <button
                        class="btn bo"
                        @click="
                          $store.commit('layout/setModalAlert', {
                            modalAlertName:
                              $modalAlertNames.MODAL_DAUM_POST_CODE,
                            callBack: fnBind
                          })
                        "
                      >
                        주소 검색
                      </button>
                    </div>
                    <div class="input">
                      <input
                        type="text"
                        placeholder="주소를 입력해 주세요"
                        disabled
                        v-model="form.userAddress"
                      />
                    </div>
                    <div class="input">
                      <input
                        type="text"
                        placeholder="상세주소를 입력해 주세요"
                        v-model="form.userAddress2"
                      />
                    </div>
                    <p
                      class="valid"
                      :class="{
                        on: $v.form.userAddress.$error
                      }"
                    >
                      필수항목입니다.
                    </p>
                    <!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">휴대폰 번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="-를 제외하고 입력해 주세요"
                        v-model="form.userPhone"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <p
                        class="valid"
                        :class="{ on: $v.form.userPhone.$error }"
                      >
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>비상연락처</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="비상연락처를 입력해 주세요"
                        v-model="form.phone"
                      />
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="inform_box mtb10">
                    <ol class="dot li_space">
                      <li class="color">
                        <span class="ol_li_txt">
                          교육신청서에 기재한 내용이 틀리거나 교육자격기준에
                          해당하지 아니한 경우에는<br />
                          수료를 취소하여도 아무런 이의를 제기하지
                          아니하겠습니다.
                        </span>
                      </li>
                      <li class="color">
                        <span class="ol_li_txt">
                          본인의 귀책사유로 인하여 수료증이 오발송되는 경우,<br />
                          재발급 비용이 추가로 발생되는 것에 이의를 제기하지
                          아니하겠습니다.
                        </span>
                      </li>
                    </ol>
                  </div>
                </li>
                <li class="form_li">
                  <div class="check_list">
                    <div class="check_list_li">
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          id="a"
                          :true-value="1"
                          :false-value="2"
                          :checked="form.isAgree"
                          v-model="form.isAgree"
                        />
                        <label for="a"
                          ><span class="essen"
                            >위 약관의 내용에 동의합니다</span
                          ></label
                        >
                        <p
                          class="valid"
                          :class="{ on: $v.form.isAgree.$error }"
                        >
                          약관에 동의해주세요.
                        </p>
                        <!--'on 추가'-->
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn" @click="fnModal">
            교육 신청하기
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'manager-edu-apply-write-index',
  data: function() {
    const educationNo = Number(this.$route.query.educationNo)
    return {
      educationNo,
      item: {},
      form: {
        name: '',
        userBirth: '',
        email: '',
        isDisorder: 1,
        memo: '',
        userPhone: '',
        phone: '',
        isAgree: '',
        userAddress: '',
        userAddress2: '',
        postalCode: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      const res = await this.$ManagerSvc.getMapEdu({
        educationNo: this.educationNo
      })
      console.log('res', res)
      this.item = res.entity.edu
      this.form = res.entity.user
      this.form.userBirth = res.entity.user.birth
      this.form.postalCode = res.entity.user.postalCode
      this.form.userAddress = res.entity.user.address
      this.form.userAddress2 = res.entity.user.address2
      this.form.isDisorder = 1
    },
    fnBind: function({ roadAddress, zonecode }) {
      this.form.userAddress = roadAddress
      this.form.postalCode = zonecode
    },
    fnModal: function() {
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EDU_APPLY_POPUP,
        data: { applyType: 1 },
        callBack: this.fnSave
      })
    },
    fnSave: async function() {
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      const params = this.$_.cloneDeep(this.form)
      params.educationNo = this.educationNo
      params.postCode = this.form.postalCode
      const res = await this.$ManagerSvc.postIntEdu(params)
      if (res.code === 1) {
        await this.$router.replace({ path: '/manager/edu/apply/done' })
      } else if (res.code === -5000) {
        alert(res.message)
      } else {
        alert(res.message)
      }
    }
  },
  validations: {
    form: {
      name: { required },
      userBirth: {
        required
      },
      email: { required },
      isDisorder: { required },
      userPhone: { required },
      userAddress: { required },
      isAgree: {
        test: function(val) {
          if (val === 1) {
            return true
          }
          return false
        }
      }
    }
  }
}
</script>

<style scoped></style>
